import React, { useState } from 'react';
import { useSecurityStatus } from '../../hooks/security';
import { Link } from 'react-router-dom';
import { PasswordUpdateModal } from './UpdatePassword';
import { UpdateUser } from './UpdateUser'
import { Grid } from '@mui/material';

const UserInfo = ({ successToast, errorToast }) => {
    const { user } = useSecurityStatus();
    const [passwordModal, setPasswordModal] = useState<boolean>(false);
    const [usernameModal, setUsernameModal] = useState<boolean>(false);

    return (
        <>
            {/* modals */}
            {passwordModal &&
                <PasswordUpdateModal
                    onHide={() => setPasswordModal(false)}
                    show={passwordModal}
                    fail={errorToast}
                    success={successToast} />
            }
            {usernameModal &&
                <UpdateUser
                    onHide={() => setUsernameModal(false)}
                    show={usernameModal}
                    fail={errorToast}
                    success={successToast} />
            }
            {/* end modals */}
            <Grid>
                <Grid container className='account-info' style={{ lineHeight: "2" }}>
                    <Grid item xs={12}>
                        <div><b>PROFILE INFORMATION</b></div>
                    </Grid>
                    <Grid item xs={5} style={{ fontSize: ".9em" }}>
                        <div><b>Username</b></div>
                    </Grid>
                    <Grid item xs={5} style={{ fontSize: ".9em" }}>
                        <div>{user.username}</div>
                    </Grid>
                    <Grid item xs={2} className='account-info-action' role="presentation" style={{ fontSize: ".9em" }}>
                        <div><Link onClick={() => setUsernameModal(true)} to="/manage">Edit</Link></div>
                    </Grid>
                    <Grid item xs={5} style={{ fontSize: ".9em" }}>
                        <div><b>Password</b></div>
                    </Grid>
                    <Grid item xs={5} style={{ fontSize: ".9em" }}>
                        <div>xxxxxxxxxx</div>
                    </Grid>
                    <Grid item xs={2} className='account-info-action' role="presentation" style={{ fontSize: ".9em" }}>
                        <div><Link to="/manage" onClick={() => setPasswordModal(true)}>Change</Link></div>
                    </Grid>
                </Grid>
            </Grid>
        </>);
}
export default UserInfo;